import { Fragment } from 'react';

import { Table } from '~/components/Elements';

import {
  Disclaimer,
  Headline,
  HeadlineSub,
  Intro,
  TableSideValue,
} from '../styles';

const Location = props => {
  const {
    data: { front_wins_track: data },
  } = props;

  return (
    <Fragment>
      {data.map((stats, index) => (
        <Fragment key={stats.track_id}>
          {index === 0 && (
            <Fragment>
              <Headline>{stats.headline}</Headline>
              <Intro>{stats.intro}</Intro>
            </Fragment>
          )}
          {data.length > 1 && <HeadlineSub>{stats.track_name}</HeadlineSub>}
          <Table>
            <thead>
              <tr>
                <th>Distans</th>
                <th>Antal lopp</th>
                <th>Segrar från spets</th>
                <th>Segerprocent</th>
              </tr>
            </thead>
            <tbody>
              {stats.count > 0 &&
                stats.results.map(stat => (
                  <tr key={stat.distance}>
                    <td>{stat.distance}</td>
                    <td>{stat.number_of_races}</td>
                    <td>{stat.front_wins}</td>
                    <td>
                      {stat.win_percent}%
                      {stat.win_percent_total && (
                        <TableSideValue>
                          {stat.win_percent_total}%
                        </TableSideValue>
                      )}
                    </td>
                  </tr>
                ))}
            </tbody>
          </Table>
          <Disclaimer>{stats.disclaimer}</Disclaimer>
        </Fragment>
      ))}
    </Fragment>
  );
};

export default Location;
